import { useEffect } from "react";

// Set the browser tab title, suffixed with the app name.
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = `${title} · Agile Software`;
  }, [title]);
}
